module.exports = __webpack_public_path__ + "static/media/uppLogin.d9c1aff3.png";